export default __webpack_public_path__ + "static/media/love-the-item-grey.8114ceea.svg";